import React, { HTMLAttributes, useContext } from "react";

import classNames from "classnames";

import { EntityGroupContext } from "./EntityGroup";
import { StyledEntityProperty } from "./Styles";

export type VisibleFromBreakpoint = "sm" | "md" | "lg" | "xl" | "2xl";
export interface IEntityCardPropertyProps
  extends HTMLAttributes<HTMLDivElement> {
  listOrder?: number;
  listWidth?: string | number;
  visibleFromBreakpoint?: VisibleFromBreakpoint;
}

export const EntityProperty: React.FC<IEntityCardPropertyProps> = ({
  listOrder,
  listWidth,
  visibleFromBreakpoint,
  className,
  ...props
}) => {
  const { renderAs } = useContext(EntityGroupContext);
  const classSuffix = `c-entity-property-${renderAs}`;
  return (
    <StyledEntityProperty
      className={classNames("c-entity-property", classSuffix, className)}
      {...props}
      $order={listOrder}
      $width={listWidth}
      $visibleFromBreakpoint={visibleFromBreakpoint}
      $renderAs={renderAs}
    />
  );
};

EntityProperty.displayName = "EntityProperty";
